var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-question-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-question-grey",
    clipPath: "url(#clip-icon-question-grey)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_20_12",
    "data-name": "Component 20 \\u2013 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(-0.848 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    transform: "translate(0.848 0)",
    fill: "#d8d8d8",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M5.662,0A4.242,4.242,0,0,0,1.894,1.993a.526.526,0,0,0,.113.72l.944.716a.525.525,0,0,0,.728-.091A2.124,2.124,0,0,1,5.492,2.255C6.165,2.255,7,2.689,7,3.342c0,.494-.408.747-1.073,1.12-.775.435-1.8.976-1.8,2.329v.214a.525.525,0,0,0,.525.525H6.236a.525.525,0,0,0,.525-.525V6.879C6.761,5.941,9.5,5.9,9.5,3.363,9.5,1.45,7.52,0,5.662,0ZM5.443,8.176A1.516,1.516,0,1,0,6.959,9.692,1.518,1.518,0,0,0,5.443,8.176Z",
    transform: "translate(4.348 4.397)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionGray);
export default __webpack_public_path__ + "static/media/icon-question-gray.5f403117a37daa03d4a96721a569a47d.svg";
export { ForwardRef as ReactComponent };